@if (searchable()) {
  <div class="position-relative mb-3">
    <svg-icon
      [name]="'search-topbar'"
      class="position-absolute top-50 start-0 translate-middle-y ms-3 svg-24"
    ></svg-icon>
    <input
      type="text"
      class="form-control form-control-lg ps-5 rounded-5"
      placeholder="Search"
      [(ngModel)]="searchTextUser"
    />
  </div>
}
<ul class="d-flex flex-column list-unstyled users-menu me-n3 pe-3">
  @for (user of usersListDisplay(); track user.id) {
    <li
      (click)="selectable() ? selectUser(user) : null"
      [class.active]="selectable() ? selectedUser()?.id === user.id : false"
    >
      <div class="d-flex align-items-center gap-2 py-2">
        <span class="user-28 flex-shrink-0"
          ><span>{{ user.initials }}</span></span
        >
        <div class="d-flex flex-column overflow-hidden">
          <h6 class="mb-0 text-truncate">{{ user.firstName }} {{ user.lastName }}</h6>
          <p class="text-muted mb-0 text-truncate" [title]="user.email ?? ''">{{ user.email ?? '-' }}</p>
        </div>
      </div>
    </li>
  }
</ul>
